export default __webpack_public_path__ + "static/media/tlo-portal-pacjenta.89b75d20.jpg";